<template>
    <div class="input">
        <div>
            <input type="checkbox" class="input__control" :value="nativeValue" v-model="newValue" :name="name" :id="id" />
            <label :for="id" :data-category="dataCategory" :data-label="dataLabel" v-html="label"></label>
        </div>
        <span v-show="value === nativeValue">
            <slot />
        </span>
    </div>
</template>

<script>
export default {
    props: {
        value: [String, Number, Boolean, Function, Object, Array, Symbol],
        label: {
            type: String,
            default: () => ''
        },
        dataCategory: {
            type: String
        },
        dataLabel: {
            type: String
        },
        name: {
            type: String,
            default: () => 'name'
        },
        id: {
            type: String
        },
        nativeValue: [String, Number, Boolean, Function, Object, Array, Symbol]
    },
    data() {
        return {
            newValue: this.value
        }
    },
    watch: {
        value(value) {
            this.newValue = value
        },
        newValue(value) {
            if (this.nativeValue === value) {
                this.$emit('input', value)
            }
        }
    }
}
</script>